import Notiflix from "notiflix";
import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { MdOutlineSwapVerticalCircle } from "react-icons/md";
import PostApiCall from "../../Api";
// import Saveicon from "../../../assets/images/dashboardimages/filesave.png";
import Sequentialize from "../../assets/images/dashboardimages/Sequentialize.png";
// import "../../../pages/Authentication/login.css";
import "./DragDropList.css";
const DragDropList = (props) => {
    const [data, setData] = useState([]);
    const [image, setImage] = useState();
    const [description, setDescription] = useState();
    const [variantDropdown, setVariantDropdown] = useState([]);
    const [variant, setVariant] = useState([]);
    const [itemName, setItemName] = useState([]);
    const [index, setIndex] = useState();
    const [id, setId] = useState();
    const handleDragEnd = (e) => {
        if (!e.destination) return;
        let tempData = Array.from(itemName);
        let [source_data] = tempData.splice(e.source.index, 1);
        tempData.splice(e.destination.index, 0, source_data);
        setItemName(tempData);
    };
    useEffect(() => {
        // console.log(props.verticalData)
        if (data.length <= 0) {
            setData(props.verticalData);
            setVariantDropdown(props.verticalDropdown)
        }
    });
    let dropdownItems = data.filter(
        (ele, ind) =>
            ind ===
            data.findIndex(
                (elem) =>
                    elem.productName === ele.productName
            )
    );
    return (
        <div className="App serialize-side-drawer">
            <h6 className="mb-4 d-flex dragdrop-side px-3 bg-white">
                <div>
                    <img
                        src={Sequentialize}
                        alt="block user"
                        className="sequence-drwa-icons ms-3 mt-1"
                        style={{ marginRight: "5px" }}
                    />
                </div>
                <div className="sequence-draw-title mx-3 ">
                    Select the Sequence in which you want the {props.for} to be displayed.
                    You can Drag and Drop the items to Sequentialize
                </div>
            </h6>
            <div className="p-3">
                <select
                    // value={item}
                    onChange={(text) => {
                        let varientNameArray = [];
                        data.filter((data) => {
                            if (text.target.value == data.productName) {
                                return data
                            }
                        }).map((item, i) => {
                            varientNameArray.push(item);
                        });
                        // console.log(varientNameArray)
                        setVariant(varientNameArray)

                    }}
                    // onChange={(text) => {
                    //     setItem(text.target.value)
                    //     Notiflix.Loading.Dots("Please wait...");
                    //     // console.log(item)
                    //     PostApiCall.postRequest(
                    //         {

                    //             whereClause: `where fld_productid=${text.target.value}`,
                    //             recordCount: 'fld_variantid as value,fld_variantname as label'
                    //         },
                    //         "GetVariantData"
                    //     ).then((results) =>
                    //         results.json().then((obj) => {
                    //             if (results.status == 200 || results.status == 201) {
                    //                 setVariantData(obj.data);
                    //                 Notiflix.Loading.Remove();
                    //             }
                    //         })
                    //     );
                    // }}
                    className="custom-select my-1 mr-sm-2"

                >
                    <option value="">
                        Select Item Name
                    </option>
                    {dropdownItems.map(
                        (product) => (
                            <option
                                key={product.fld_product_id}
                                value={product.productName}
                            >
                                {product.productName}
                            </option>
                        )
                    )}
                </select>
                <select
                    // value={DesignData}
                    onChange={(text) => {
                        // console.log(text.target.value)
                        let ItemNameArray = [];
                        data.filter((data) => {
                            if (text.target.value == data.fld_variant_id) {
                                return data
                            }
                        }).map((item, i) => {
                            ItemNameArray.push(item);
                        });
                        setItemName(ItemNameArray)
                    }}
                    // onChange={(text) => {
                    //     setItem(text.target.value)
                    //     Notiflix.Loading.Dots("Please wait...");
                    //     // console.log(item)
                    //     PostApiCall.postRequest(
                    //         {

                    //             whereClause: `where fld_variant_id=${text.target.value
                    //                 }`,
                    //             recordCount: '*'
                    //         },
                    //         "GetDesign"
                    //     ).then((results) =>
                    //         results.json().then((obj) => {
                    //             if (results.status == 200 || results.status == 201) {
                    //                 setDesignData(obj.data);
                    //                 Notiflix.Loading.Remove();
                    //             }
                    //         })
                    //     );
                    // }}
                    className="custom-select my-1 mr-sm-2"

                >
                    <option value="">
                        Select Variant Name
                    </option>
                    {/* {console.log(variant)} */}
                    {variant.length != 0 ? variant.map(
                        (product) => (
                            <option
                                // key={product.fld_variant_id}
                                value={product.fld_variant_id}
                            >
                                {product.variantName}
                            </option>
                        )
                    )
                        : ""}
                    {/* <option
                    // key={product.value}
                    // value={product.value}
                    >
                        {variantName.variantName}
                    </option> */}

                </select>
            </div>
            <DragDropContext onDragEnd={handleDragEnd}>
                <div className="table borderd mb-0 pb-0 px-3">
                    <Droppable droppableId="droppable-1">
                        {(provider) => (
                            <div
                                className="text-capitalize"
                                ref={provider.innerRef}
                                {...provider.droppableProps}
                            >
                                {itemName?.map((user, index) => (
                                    <Draggable
                                        key={"" + user.fld_design_id}
                                        draggableId={"" + user.fld_design_id}
                                        index={index}
                                    >
                                        {(provider) => (
                                            <div
                                                className="container-content-design sequentialize-parent"
                                                {...provider.draggableProps}
                                                value={index}
                                                ref={provider.innerRef}
                                            >
                                                <div
                                                    className="image d-flex"
                                                    key={index}
                                                    style={{ width: "20%", flex: 1 }}
                                                >
                                                    {/* <img
                                                            className="sequentialize-img"
                                                            src={user.fld_verticalImage}
                                                            value={image}
                                                            onChange={(e) => setImage(e.target.value)}
                                                        /> */}
                                                    <span className="p-3">{user.fld_design_name}</span>
                                                    <div
                                                        className="description"
                                                        value={description}
                                                        onChange={(e) => setDescription(e.target.value)}
                                                    >
                                                        {user.variantName}

                                                    </div>
                                                </div>
                                                <div {...provider.dragHandleProps}>
                                                    {" "}
                                                    <MdOutlineSwapVerticalCircle />
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provider.placeholder}
                            </div>
                        )}
                    </Droppable>
                </div>
            </DragDropContext>
            <div className="sequence-save-btn bg-white">
                <a
                    onClick={(e) => {
                        {
                            e.preventDefault();
                            Notiflix.Loading.Dots("Sequence saved successfully...");
                            PostApiCall.postRequest(
                                {
                                    sequence: data,
                                    for: props.for,
                                },
                                "AddSequence"
                            ).then((response) => {
                                response.json().then((result) => {
                                    Notiflix.Loading.Remove();
                                    Notiflix.Notify.Success(
                                        "Saved Successfully"
                                    );
                                });
                            });
                        }
                    }}
                    className="btn Bechofy-btn waves-effect waves-light btn-sm float-right my-3 py-2 px-5"
                    style={{ fontSize: "15px" }}
                >
                    {/* <img src={Saveicon} alt="block user" className="btnicons mx-2"></img>{" "} */}
                    Save this Sequence
                </a>
            </div>
        </div>
    );
};
export default DragDropList;
